import React from "react";
import { GALLERY } from "../lib/site";

export default function Gallery() {
  return (
    <section id="gallery" data-testid="gallery-section" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-yellow-100 text-yellow-800 text-xs font-bold uppercase tracking-wider">
            Our Work
          </span>
          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900" style={{ fontFamily: "Outfit" }}>
            Gallery — <span className="text-red-600">Real Shifting</span> Work
          </h2>
          <p className="mt-4 text-slate-600">
            Hamari team Delhi NCR me daily kaam karti hai — yahan dekhiye humare professional shifting moments.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5">
          {GALLERY.map((src, idx) => (
            <div
              key={idx}
              data-testid={`gallery-item-${idx}`}
              className={`group relative overflow-hidden rounded-2xl shadow-md hover:shadow-2xl transition-all ${
                idx === 0 ? "md:row-span-2 md:col-span-1" : ""
              }`}
            >
              <img
                src={src}
                alt={`Shifting work ${idx + 1}`}
                loading="lazy"
                className={`w-full object-cover transition-transform duration-700 group-hover:scale-110 ${
                  idx === 0 ? "h-72 md:h-full" : "h-44 sm:h-56"
                }`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-blue-900/70 via-blue-900/0 to-transparent opacity-0 group-hover:opacity-100 transition" />
              <div className="absolute bottom-3 left-3 right-3 text-white text-sm font-semibold opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition">
                Professional Shifting #{idx + 1}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
